import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: navigator.language.slice(0, 2),
    fallbackLocale: 'en',
    messages: {
        en: {
            login: {
                first: 'First, <a href="https://home.pulsesms.app/overview/signup.html" target="_blank">sign up</a> for an account from the <b>Text from any device</b> option in the navigation drawer of the phone app.',
                error: 'Email or Password incorrect',
                expiredAccounts: 'Accounts are expired if no messages are sent for 60 days.',
                expiredAccountsHelp: 'Learn more',
                subscriptionExpiredError: {
                    title: 'Your subscription has expired.',
                    description: 'Please resubscribe on your primary device to continue sending and receiving messages across all your devices.'
                },
                email: 'Email Address',
                password: 'Password',
                showpassword: 'Show password',
                hidepassword: 'Hide password',
                forgotpassword: 'Forgot your password?',
                iphone: 'Have an <i>iPhone</i>?',
                login: 'Log in'
            },
            sidebar: {
                conversations: 'Conversations',
                unreadconversations: 'Unread Conversations',
                privateconversations: 'Private Conversations',
                archive: 'Archived Conversations',
                folders: 'Manage Folders',
                scheduled: 'Scheduled Messages',
                blacklist: 'Blacklist',
                blocklist: 'Blocklist',
                searchconversations: 'Search Conversations'
            },
            api: {
                disconnected: 'You\'ve been disconnected. We\'re trying to reconnect you...',
                back: 'And we\'re back !',
                somethingWrong: 'Something went wrong. Kindly try again later and if problem persists, contact support.'
            },
            conversations: {
                pinned: 'Pinned',
                today: 'Today',
                yesterday: 'Yesterday',
                thisweek: 'This Week',
                thismonth: 'This Month',
                older: 'Older',
                noconv: 'No Conversations',
                deleteconfirm: 'Are you sure you want to delete these conversations?',
                deletefolderconfirm: 'Are you sure you want to delete this folder?',
                nounread: 'No unread conversations',
                markallreadconfirm: 'Mark {count} conversations as read? Each one is synced to your phone separately.',
                markingread: 'Marking {count} conversation as read… | Marking {count} conversations as read…',
                markedread: 'Marked {count} conversation as read | Marked {count} conversations as read',
                markreadfailed: 'Couldn\'t mark the conversation as read. Refresh to check it. | Couldn\'t mark {failed} of {count} conversations as read. Refresh to see which.'
            },
            folders: {
                none: 'No folders yet. Create one to organize your conversations.',
                create: 'Create Folder',
                edit: 'Edit Folder',
                name: 'Folder name',
                name_required: 'Folder name is required',
                created: 'Created folder: {name}',
                create_failed: 'Couldn\'t create the folder',
                updated: 'Folder updated',
                update_failed: 'Couldn\'t update the folder',
                deleted: 'Deleted folder: {name}',
                delete_failed: 'Couldn\'t delete the folder',
                premium: 'Creating folders is a premium feature. Upgrade from the Pulse SMS app on your phone to use it.',
                conversations: 'Conversations',
                filter: 'Filter conversations',
                loading_conversations: 'Loading conversations…',
                no_conversations: 'No conversations',
                load_conversations_failed: 'Couldn\'t load your conversations',
                in_other_folder: 'In another folder',
                assign_failed: 'Couldn\'t change the folder for {title}'
            },
            passcode: {
                create: 'Create Passcode',
                new_passcode: 'New Passcode',
                enter: 'Enter Passcode',
                passcode: 'Passcode'
            },
            dialog: {
                continue: 'Continue',
                cancel: 'Cancel',
                save: 'Save',
                close: 'Close',
                create: 'Create',
                delete: 'Delete',
                typeHere: 'Type here...',
                forgotPasscode: 'Forgot Passcode?'
            },
            sendbar: {
                type: 'Type message...'
            },
            thread: {
                settings: {
                    updatecolors: 'Update Theme Colors',
                    pin: 'Pin Conversation',
                    mute: 'Mute Conversation',
                    private: 'Private Conversation',
                    conversationtitle: 'Conversation Title',
                    updatetitle: 'Update Conversation Title',
                    folder: 'Folder',
                    selectfolder: 'Select Folder for Conversation',
                    nofolder: 'No Folder',
                    folder_private: 'Private conversations can\'t be added to folders',
                    folder_failed: 'Couldn\'t change the folder',
                    folder_loading: 'Loading…',
                    folder_load_failed: 'Couldn\'t load your folders. Reopen this page to try again.'
                },
                delete: {
                    delete: 'Delete',
                    cancel: 'Cancel',
                    thread: 'Are you sure that you want to delete this conversation?',
                    message: 'Are you sure that you want to delete this message?'
                },
                blacklisted: 'Contact blacklisted and moved to the archive.',
                groupblacklisted: 'Cannot blacklist group conversations.',
                newmessage: 'New Message',
                show: 'Show'
            },
            menus: {
                account: 'My Account',
                settings: 'Settings',
                help: 'Help and Feedback',
                login: 'Login',
                logout: 'Logout',
                convinfo: 'Conversation Information',
                about: 'About',
                blacklist: 'Blacklist Contact',
                delete: 'Delete Conversation',
                archive: 'Archive Conversation',
                unarchive: 'Move to Inbox',
                deleteselected: 'Delete Conversations',
                markunread: 'Mark as Unread',
                markread: 'Mark as Read',
                markallread: 'Mark All as Read',
                archiveselected: 'Archive Conversations',
                unarchiveselected: 'Move Conversations to Inbox',
                selectall: 'Select All Conversations',
                convsettings: 'Conversation Settings',
                support: 'Support',
                licenses: 'Licenses'
            },
            compose: {
                norecipient: 'No Recipient',
                type: 'Search contacts or enter phone numbers (separated by a semicolon)...',
                cantfind: 'Can\'t find your contact?',
                alreadyadded: '{name} has already been added',
                downloading: 'Downloading contacts...'
            },
            contact: {
                group: 'Group',
                mobile: 'Mobile',
                home: 'Home',
                work: 'Work',
                other: 'Other'
            },
            blacklist: {
                none: 'No Blacklisted Numbers',
                phone: 'Phone Number',
                create_phone: 'Blacklist by Phone',
                create_phrase: 'Blacklist by Phrase',
                phrase: 'Phrase',
                delete: 'Remove blacklist',
                type_number: 'Number',
                type_phrase: 'Phrase',
                ambiguous: '"{entry}" doesn\'t look like a phone number. Do you want to block messages that contain this text, or block a sender named this?',
                block_text: 'Block text',
                block_sender: 'Block sender',
                create_failed: 'Couldn\'t add the blocklist entry. Please try again.',
                already_blocked: '"{entry}" is already in your blocklist.',
                deleteconfirm: 'Remove "{entry}" from your blocklist?',
                export: 'Export Blocklist',
                import: 'Import Blocklist',
                import_confirm: 'Import {count} entries? Each one is synced to your phone separately.',
                importing: 'Importing {done} of {total}…',
                imported: 'Imported {added}, skipped {skipped} already blocked, {failed} failed.',
                import_error: 'Couldn\'t read any entries from that file. Use a CSV exported from Pulse (phone_number,phrase).'
            },
            scheduled: {
                repeat: {
                    never: 'Do not repeat',
                    daily: 'Repeat daily',
                    weekly: 'Repeat weekly',
                    monthly: 'Repeat monthly',
                    yearly: 'Repeat yearly'
                },
                media: 'Media, within a scheduled message, can only be viewed on the phone app.',
                image: 'Attached image',
                attach_image: 'Attach image',
                remove_image: 'Remove image',
                preparing_image: 'Preparing image…',
                image_unsupported: 'That file type isn\'t supported. Choose an image.',
                image_too_large: 'That image is too large to send.',
                create_failed: 'Couldn\'t schedule the message. Please try again.',
                text_failed: 'The image was scheduled, but the text message couldn\'t be. Tap Create to try the text again.',
                image_scheduled: 'Scheduled',
                image_loading: 'Loading image…',
                image_unavailable: 'Image unavailable',
                view_image: 'View image',
                media_edit: 'This message contains media, which stays as it is. You can change when it\'s sent.'
            },
            settings: {
                theme: 'Theme Settings',
                refresh: 'Refresh settings from phone',
                explanatory_intro: 'These settings are pulled from the app, when you click this preference. You can also change them manually, from this page.',
                base: 'Base Theme',
                daynight: 'Day / Night',
                light: 'Light',
                dark: 'Dark',
                black: 'Black',
                primary: 'Primary Color',
                darkprimary: 'Primary Color Dark',
                accent: 'Accent Color',
                applyeverywhere: 'Apply Colors to all Conversations',
                applyprimary: 'Apply Primary Color to App Bar',
                messagetimestamp: 'Display Timestamp on Every Message',
                conversationcategories: 'Display Conversations in Date Categories',
                webspecific: 'Web Specific Settings',
                advanced: 'Advanced Settings',
                shownotifs: 'Show Notifications',
                entersend: 'Use Enter to Send Messages',
                showconversationsnotinfolders: 'Show Only Conversations Not in Folders in the Main List',
                showunreadasdefault: 'Show Unread Conversations as Default',
                yes: 'Yes',
                no: 'No',
                private_conversations_passcode_title: 'Private Conversations Passcode',
                private_conversations_passcode_description: 'Setting a password will require you to enter it before viewing private conversations',
                clean_up_old_messages_title: 'Clean Up Old Messages',
                clean_up_old_messages_description: 'This runs once per day to delete any messages older than your selected time period',
                clean_up_old_messages: {
                    never: 'Never',
                    one_week: 'One Week',
                    two_weeks: 'Two Weeks',
                    one_month: 'One Month',
                    three_months: 'Three Months',
                    six_months: 'Six Months',
                    one_year: 'One Year'
                },
                unknown_number_reception_title: 'Receiving Messages from Non-Contacts',
                unknown_number_reception: {
                    default: 'Receive messages normally',
                    mute: 'Mute the conversations to prevent notifications',
                    block: 'Immediately discard the message as spam, Be careful and remember that you turned this on!'
                },
                auto_reply_configuration_title: 'Auto Reply Configuration',
                auto_reply_configuration_description: 'Set up automated replies based on your situation',
                auto_reply: {
                    empty: 'No auto replies found.',
                    create: 'Create Auto Reply',
                    keyword: 'Keyword',
                    response: 'Response',
                    prompt: 'Which type of auto reply would you like to create?',
                    type_contact: 'CONTACT',
                    type_keyword: 'KEYWORD',
                    edit: 'Edit Auto Reply',
                    edit_action: 'Edit',
                    contact: 'Contact',
                    updated: 'Auto reply updated',
                    update_failed: 'Failed to update auto reply',
                    delete_confirm: 'Delete auto reply?',
                    deleted: 'Auto reply deleted',
                    delete_failed: 'Failed to delete auto reply',
                }
            },
            account: {
                upgrade_subscription: 'Want to change or upgrade your subscription? Head to the "My Account" section, in the Android app!',
                expiration_reminder: 'Reminder: Your Pulse SMS account will remain active if you send a message within 60 days, otherwise the account will expire.'
            },
            experiments: {
                disclaimer: 'Disclaimer',
                explanatory_intro: 'These preferences come with no support and no guarantee that they will continue to exist. As an open source app, they will be useful to test new features and provide developers with the means of implementing their own tweaks into the app. Use with caution and do not rely on them, unless you are maintaining them. They are meant to be experiments.',
                archive_after_send: 'Archive Conversation After Sending Any Message',
                larger_app_bar: 'Display Larger App Bar',
                unread_count_in_sidebar: 'Display Unread Messages Count in Sidebar'
            },
            templates: {
                none: 'No Templates',
                create: 'Create Template',
                edit: 'Edit Template'
            },
            drafts: {
                title: 'Drafts',
                none: 'No Drafts',
                unknown: 'Unknown Conversation',
                image: 'Image',
                video: 'Video',
                audio: 'Audio',
                contact: 'Contact Card',
                attachment: 'Attachment',
                copy: 'Copy Text',
                copied: 'Draft copied',
                delete: 'Delete',
                deleteconfirm: 'Delete the drafts for this conversation?',
                deleted: 'Drafts deleted'
            }

        },
        fr: {
            login: {
                first: 'D\'abord, <a href="https://home.pulsesms.app/overview/signup.html" target="_blank">enregistrez-vous</a> avec le bouton <b>SMS depuis d\'autres appareils</b> dans le menu de navigation de l\'application mobile.',
                error: 'Email ou Mot de passe incorrect',
                expiredAccounts: 'Les comptes expirent si aucun message n\'est envoyé pendant 60 jours.',
                expiredAccountsHelp: 'En savoir plus',
                subscriptionExpiredError: {
                    title: 'Votre abonnement a expiré.',
                    description: 'Veuillez vous réabonner sur votre appareil principal pour continuer à envoyer et recevoir des messages sur tous vos appareils.'
                },
                email: 'Adresse email',
                password: 'Mot de passe',
                showpassword: 'Afficher le mot de passe',
                hidepassword: 'Masquer le mot de passe',
                forgotpassword: 'Mot de passe oublié ?',
                iphone: 'Vous avez un <i>iPhone</i>?',
                login: 'Connexion'
            },
            sidebar: {
                conversations: 'Conversations',
                privateconversations: 'Conversations privées',
                archive: 'Conversations archivées',
                folders: 'Gérer les dossiers',
                scheduled: 'Messages programmés',
                blacklist: 'Liste noire',
                blocklist: 'Liste de blocage',
            },
            api: {
                disconnected: 'Vous avez été déconnecté. Nous tentons de vous reconnecter...',
                back: 'Connexion établie !',
                somethingWrong: 'Quelque chose s\'est mal passé. Veuillez réessayer plus tard et si le problème persiste, contactez le support.'
            },
            conversations: {
                pinned: 'Épinglés',
                today: 'Aujourd\'hui',
                yesterday: 'Hier',
                thisweek: 'Cette semaine',
                thismonth: 'Ce mois ci',
                older: 'Anciens',
                noconv: 'Aucune conversation',
                deletefolderconfirm: 'Voulez-vous vraiment supprimer ce dossier ?',
                nounread: 'Aucune conversation non lue',
                markallreadconfirm: 'Marquer {count} conversations comme lues ? Chacune est synchronisée séparément avec votre téléphone.',
                markingread: 'Marquage de {count} conversation comme lue… | Marquage de {count} conversations comme lues…',
                markedread: '{count} conversation marquée comme lue | {count} conversations marquées comme lues',
                markreadfailed: 'Impossible de marquer la conversation comme lue. Actualisez pour vérifier. | Impossible de marquer comme lues {failed} des {count} conversations. Actualisez pour voir lesquelles.'
            },
            folders: {
                none: 'Aucun dossier. Créez-en un pour organiser vos conversations.',
                create: 'Créer un dossier',
                edit: 'Modifier le dossier',
                name: 'Nom du dossier',
                name_required: 'Le nom du dossier est obligatoire',
                created: 'Dossier créé : {name}',
                create_failed: 'Impossible de créer le dossier',
                updated: 'Dossier mis à jour',
                update_failed: 'Impossible de mettre à jour le dossier',
                deleted: 'Dossier supprimé : {name}',
                delete_failed: 'Impossible de supprimer le dossier',
                premium: 'La création de dossiers est une fonctionnalité premium. Passez à premium depuis l\'application Pulse SMS sur votre téléphone pour l\'utiliser.',
                conversations: 'Conversations',
                filter: 'Filtrer les conversations',
                loading_conversations: 'Chargement des conversations…',
                no_conversations: 'Aucune conversation',
                load_conversations_failed: 'Impossible de charger vos conversations',
                in_other_folder: 'Dans un autre dossier',
                assign_failed: 'Impossible de changer le dossier de {title}'
            },
            passcode: {
                create: 'Créer un mot de passe',
                new_passcode: 'Nouveau mot de passe',
                enter: 'Entrez le code secret',
                passcode: 'Code secret'
            },
            dialog: {
                continue: 'Continuer',
                cancel: 'Abandonner',
                save: 'Sauvegarder',
                close: 'Fermer',
                create: 'Créer',
                delete: 'Supprimer',
                forgotPasscode: 'Mot de passe oublié ?'
            },
            sendbar: {
                type: 'Composez votre message'
            },
            thread: {
                settings: {
                    updatecolors: 'Changer les couleurs',
                    pin: 'Épingler la conversation',
                    mute: 'Rendre muet',
                    private: 'Conversation privée',
                    folder: 'Dossier',
                    selectfolder: 'Choisir le dossier de la conversation',
                    nofolder: 'Aucun dossier',
                    folder_private: 'Les conversations privées ne peuvent pas être ajoutées à un dossier',
                    folder_failed: 'Impossible de changer le dossier',
                    folder_loading: 'Chargement…',
                    folder_load_failed: 'Impossible de charger vos dossiers. Rouvrez cette page pour réessayer.'
                }
            },
            menus: {
                account: 'Mon compte',
                settings: 'Paramètres',
                help: 'Aide et retours',
                logout: 'Déconnexion',
                login: 'Connexion',
                about: 'Sur',
                convinfo: 'Informations',
                blacklist: 'Bloquer',
                delete: 'Supprimer',
                archive: 'Archiver',
                unarchive: 'Désarchiver',
                markunread: 'Marquer comme non-lu',
                markread: 'Marquer comme lu',
                markallread: 'Tout marquer comme lu',
                convsettings: 'Paramètres',
                support: 'Soutien',
                licenses: 'Licenses'
            },
            compose: {
                norecipient: 'Pas de destinataire',
                type: 'Entrez le nom d\'un contact',
                cantfind: 'Contact introuvable ?',
                alreadyadded: '{name} est déjà destinataire'
            },
            blacklist: {
                none: 'Liste noire vide',
                phone: 'Numéro de téléphone',
                create: 'Ajouter un blocage',
                type_number: 'Numéro',
                type_phrase: 'Phrase',
                ambiguous: '« {entry} » ne ressemble pas à un numéro de téléphone. Voulez-vous bloquer les messages contenant ce texte, ou bloquer un expéditeur portant ce nom ?',
                block_text: 'Bloquer le texte',
                block_sender: 'Bloquer l\'expéditeur',
                create_failed: 'Impossible d\'ajouter l\'entrée à la liste de blocage. Veuillez réessayer.',
                already_blocked: '« {entry} » est déjà dans votre liste de blocage.',
                deleteconfirm: 'Retirer « {entry} » de votre liste de blocage ?',
                export: 'Exporter la liste de blocage',
                import: 'Importer une liste de blocage',
                import_confirm: 'Importer {count} entrées ? Chacune est synchronisée séparément avec votre téléphone.',
                importing: 'Importation {done} sur {total}…',
                imported: '{added} importées, {skipped} déjà bloquées ignorées, {failed} en échec.',
                import_error: 'Aucune entrée lisible dans ce fichier. Utilisez un CSV exporté depuis Pulse (phone_number,phrase).'
            },
            scheduled: {
                image: 'Image jointe',
                attach_image: 'Joindre une image',
                remove_image: 'Retirer l\'image',
                preparing_image: 'Préparation de l\'image…',
                image_unsupported: 'Ce type de fichier n\'est pas pris en charge. Choisissez une image.',
                image_too_large: 'Cette image est trop volumineuse pour être envoyée.',
                create_failed: 'Impossible de programmer le message. Veuillez réessayer.',
                text_failed: 'L\'image a été programmée, mais pas le message texte. Appuyez sur Créer pour réessayer le texte.',
                image_scheduled: 'Programmée',
                image_loading: 'Chargement de l\'image…',
                image_unavailable: 'Image indisponible',
                view_image: 'Voir l\'image',
                media_edit: 'Ce message contient un média, qui reste inchangé. Vous pouvez modifier son heure d\'envoi.'
            },
            settings: {
                theme: 'Paramètre d\'apparence',
                refresh: 'Récupérer les paramètres du téléphone',
                explanatory_intro: 'Ces paramètres sont récupérés depuis l\'application, lorsque vous cliquez dessus. Vous pouvez aussi les changer manuellement depuis cette page.',
                base: 'Thème de base',
                daynight: 'Jour / Nuit',
                light: 'Clair',
                dark: 'Sombre',
                black: 'Noir',
                primary: 'Couleur primaire',
                darkprimary: 'Couleur primaire foncée',
                accent: 'Couleur secondaire',
                applyeverywhere: 'Appliquer ces couleurs pour toutes les conversations',
                applyprimary: 'Appliquer la couleur primaire à la barre de navigation',
                webspecific: 'Paramètres spécifiques au web',
                advanced: 'Paramètres avancés',
                shownotifs: 'Afficher les notifications',
                entersend: 'La touche entrée envoie le message',
                showconversationsnotinfolders: 'Afficher uniquement les conversations hors dossiers dans la liste principale',
                showunreadasdefault: 'Afficher les conversations non lues par défaut',
                yes: 'Oui',
                no: 'Non',
                private_conversations_passcode_title: 'Code d’accès aux conversations privées',
                private_conversations_passcode_description: "La définition d'un mot de passe vous obligera à le saisir avant de visualiser les conversations privées",
                clean_up_old_messages_title: 'Nettoyer les anciens messages',
                clean_up_old_messages_description: "Cela s'exécute une fois par jour pour supprimer tous les messages plus anciens que la période sélectionnée.",
                clean_up_old_messages: {
                    never: 'Jamais',
                    one_week: 'Une Semaine',
                    two_weeks: 'Deux Semaines',
                    one_month: 'Un Mois',
                    three_months: 'Trois Mois',
                    six_months: 'Six Mois',
                    one_year: 'Un An'
                },
                unknown_number_reception_title: 'Recevoir des messages de non-contacts',
                unknown_number_reception: {
                    default: 'Recevoir des messages normalement',
                    mute: 'Couper le son des conversations pour éviter les notifications',
                    block: 'Supprimer immédiatement le message comme spam. Soyez prudent et souvenez-vous que vous avez activé cette option !'
                },
                auto_reply_configuration_title: 'Configuration de la réponse automatique',
                auto_reply_configuration_description: 'Configurez des réponses automatiques en fonction de votre situation',
                auto_reply: {
                    empty: 'Aucune réponse automatique trouvée.',
                    create: 'Créer une réponse automatique',
                    keyword: 'Mot-clé',
                    response: 'Réponse',
                    prompt: 'Quel type de réponse automatique souhaitez-vous créer ?',
                    type_contact: 'CONTACT',
                    type_keyword: 'MOT-CLÉ',
                    edit: 'Modifier la réponse automatique',
                    edit_action: 'Modifier',
                    contact: 'Contact',
                    updated: 'Réponse automatique mise à jour',
                    update_failed: 'Échec de la mise à jour de la réponse automatique',
                    delete_confirm: 'Supprimer la réponse automatique ?',
                    deleted: 'Réponse automatique supprimée',
                    delete_failed: 'Échec de la suppression de la réponse automatique',
                }
            },
            account: {
                expiration_reminder: 'Rappel : votre compte Pulse SMS reste actif si vous envoyez un message dans les 60 jours, sinon le compte expirera.'
            },
            drafts: {
                title: 'Brouillons',
                none: 'Aucun brouillon',
                unknown: 'Conversation inconnue',
                image: 'Image',
                video: 'Vidéo',
                audio: 'Audio',
                contact: 'Carte de contact',
                attachment: 'Pièce jointe',
                copy: 'Copier le texte',
                copied: 'Brouillon copié',
                delete: 'Supprimer',
                deleteconfirm: 'Supprimer les brouillons de cette conversation ?',
                deleted: 'Brouillons supprimés'
            }
        },
        sv: {
            login: {
                first: '<a href="https://home.pulsesms.app/overview/signup.html" target="_blank">Skapa</a> först ett konto genom att klicka på <b>Skriv från valfri enhet</b> i menyn i telefonens app.',
                error: 'Fel e-post eller lösenord',
                expiredAccounts: 'Konton upphör om inga meddelanden skickas under 60 dagar.',
                expiredAccountsHelp: 'Läs mer',
                subscriptionExpiredError: {
                    title: 'Ditt abonnemang har löpt ut.',
                    description: 'Prenumerera igen på din primära enhet för att fortsätta skicka och ta emot meddelanden på alla dina enheter.'
                },
                email: 'Epostadress',
                password: 'Lösenord',
                showpassword: 'Visa lösenord',
                hidepassword: 'Dölj lösenord',
                forgotpassword: 'Glömt ditt lösenord?',
                iphone: 'Har du en <i>iPhone</i>?',
                login: 'Logga in'
            },
            sidebar: {
                conversations: 'Konversationer',
                unreadconversations: 'Olästa konversationer',
                privateconversations: 'Privata konversationer',
                archive: 'Arkiverade konversationer',
                folders: 'Hantera mappar',
                scheduled: 'Schemalagda meddelanden',
                blacklist: 'Svartlistade',
                blocklist: 'Blocklista',
                searchconversations: 'Sök konversationer'
            },
            api: {
                disconnected: 'Du har blivit frånkopplad. Försöker koppla upp igen...',
                back: 'Återuppkopplad!',
                somethingWrong: 'Något gick fel. Försök igen senare och kontakta supporten om problemet kvarstår.'
            },
            conversations: {
                pinned: 'Pinnad',
                today: 'Idag',
                yesterday: 'Igår',
                thisweek: 'Denna vecka',
                thismonth: 'Denna månad',
                older: 'Äldre',
                noconv: 'Inga konversationer',
                deleteconfirm: 'Är du säker på att du vill radera dessa konversationer?',
                deletefolderconfirm: 'Är du säker på att du vill radera den här mappen?',
                nounread: 'Inga olästa konversationer',
                markallreadconfirm: 'Markera {count} konversationer som lästa? Var och en synkas separat till din telefon.',
                markingread: 'Markerar {count} konversation som läst… | Markerar {count} konversationer som lästa…',
                markedread: '{count} konversation markerad som läst | {count} konversationer markerade som lästa',
                markreadfailed: 'Kunde inte markera konversationen som läst. Uppdatera för att kontrollera. | Kunde inte markera {failed} av {count} konversationer som lästa. Uppdatera för att se vilka.'
            },
            folders: {
                none: 'Inga mappar ännu. Skapa en för att organisera dina konversationer.',
                create: 'Skapa mapp',
                edit: 'Redigera mapp',
                name: 'Mappnamn',
                name_required: 'Mappnamn krävs',
                created: 'Skapade mapp: {name}',
                create_failed: 'Kunde inte skapa mappen',
                updated: 'Mappen uppdaterades',
                update_failed: 'Kunde inte uppdatera mappen',
                deleted: 'Raderade mapp: {name}',
                delete_failed: 'Kunde inte radera mappen',
                premium: 'Att skapa mappar är en premiumfunktion. Uppgradera i Pulse SMS-appen på din telefon för att använda den.',
                conversations: 'Konversationer',
                filter: 'Filtrera konversationer',
                loading_conversations: 'Läser in konversationer…',
                no_conversations: 'Inga konversationer',
                load_conversations_failed: 'Kunde inte läsa in dina konversationer',
                in_other_folder: 'I en annan mapp',
                assign_failed: 'Kunde inte byta mapp för {title}'
            },
            passcode: {
                create: 'Skapa lösenord',
                new_passcode: 'Nytt lösenord',
                enter: 'Skriv in lösenord',
                passcode: 'Lösenord'
            },
            dialog: {
                continue: 'Fortsätt',
                cancel: 'Avbryt',
                save: 'Spara',
                close: 'Stäng',
                create: 'Skapa',
                delete: 'Radera',
                forgotPasscode: 'Glömt lösenordet?'
            },
            sendbar: {
                type: 'Skriv meddelande...'
            },
            thread: {
                settings: {
                    updatecolors: 'Ändra temafärger',
                    pin: 'Pinna konversationer',
                    mute: 'Tysta konversationer',
                    private: 'Privata konversationer',
                    folder: 'Mapp',
                    selectfolder: 'Välj mapp för konversationen',
                    nofolder: 'Ingen mapp',
                    folder_private: 'Privata konversationer kan inte läggas till i mappar',
                    folder_failed: 'Kunde inte byta mapp',
                    folder_loading: 'Läser in…',
                    folder_load_failed: 'Kunde inte läsa in dina mappar. Öppna sidan igen för att försöka på nytt.'
                },
                delete: {
                    delete: 'Radera',
                    cancel: 'Avbryt',
                    thread: 'Är du säker på att du vill radera denna konversation?',
                    message: 'Är du säker på att du vill radera detta meddelande?'
                },
                blacklisted: 'Kontakten svartlistad och flyttad till arkivet.',
                groupblacklisted: 'Kan inte svartlista gruppkonversationer.',
                newmessage: 'Nytt meddelande',
                show: 'Visa'
            },
            menus: {
                account: 'Mitt konto',
                settings: 'Inställningar',
                help: 'Hjälp och feedback',
                logout: 'Logga ut',
                login: 'Logga in',
                about: 'Handla om',
                convinfo: 'Konversationsinformation',
                blacklist: 'Svarlista kontakt',
                delete: 'Radera konversation',
                archive: 'Arkivera konversation',
                unarchive: 'Flytta till Inkorgen',
                deleteselected: 'Radera konversation',
                markunread: 'Markera som oläst',
                markread: 'Markera som läst',
                markallread: 'Markera alla som lästa',
                archiveselected: 'Arkivera konversation',
                unarchiveselected: 'Flytta konversation till Inkorgen',
                selectall: 'Markera alla konversationer',
                convsettings: 'Konversationsinställningar',
                support: 'Stöd',
                licenses: 'Licenser'
            },
            compose: {
                norecipient: 'Ingen mottagare',
                type: 'Sök kontakter eller skriv ett eller flera telefonnummer (separerade med semikolon)...',
                cantfind: 'Kan inte hitta kontakt?',
                alreadyadded: '{name} har redan lagts till',
                downloading: 'Laddar ner kontakter...'
            },
            contact: {
                group: 'Grupp',
                mobile: 'Mobil',
                home: 'Hem',
                work: 'Arbete',
                other: 'Annan'
            },
            blacklist: {
                none: 'Inga svartlistade nummer',
                phone: 'Telefonnummer',
                create_phone: 'Svarlista telefonnummer',
                create_phrase: 'Svartlista en fras',
                phrase: 'Fras',
                delete: 'Radera svartlista',
                type_number: 'Nummer',
                type_phrase: 'Fras',
                ambiguous: '"{entry}" ser inte ut som ett telefonnummer. Vill du blockera meddelanden som innehåller den här texten, eller blockera en avsändare med det här namnet?',
                block_text: 'Blockera text',
                block_sender: 'Blockera avsändare',
                create_failed: 'Kunde inte lägga till posten i blockeringslistan. Försök igen.',
                already_blocked: '"{entry}" finns redan i din blocklista.',
                deleteconfirm: 'Ta bort "{entry}" från din blocklista?',
                export: 'Exportera blocklista',
                import: 'Importera blocklista',
                import_confirm: 'Importera {count} poster? Var och en synkas separat till din telefon.',
                importing: 'Importerar {done} av {total}…',
                imported: '{added} importerade, {skipped} redan blockerade hoppades över, {failed} misslyckades.',
                import_error: 'Kunde inte läsa några poster från filen. Använd en CSV som exporterats från Pulse (phone_number,phrase).'
            },
            scheduled: {
                repeat: {
                    never: 'Upprepa ej',
                    daily: 'Upprepa dagligen',
                    weekly: 'Upprepa varje vecka',
                    monthly: 'Upprepa varje månad',
                    yearly: 'Upprepa varje år'
                },
                media: 'Media i ett schemalagt meddelande kan bara ses genom telefonappen.',
                image: 'Bifogad bild',
                attach_image: 'Bifoga bild',
                remove_image: 'Ta bort bild',
                preparing_image: 'Förbereder bild…',
                image_unsupported: 'Den filtypen stöds inte. Välj en bild.',
                image_too_large: 'Bilden är för stor för att skickas.',
                create_failed: 'Kunde inte schemalägga meddelandet. Försök igen.',
                text_failed: 'Bilden schemalades, men inte textmeddelandet. Tryck på Skapa för att försöka med texten igen.',
                image_scheduled: 'Schemalagd',
                image_loading: 'Läser in bild…',
                image_unavailable: 'Bilden är inte tillgänglig',
                view_image: 'Visa bild',
                media_edit: 'Meddelandet innehåller media, som lämnas oförändrat. Du kan ändra när det skickas.'
            },
            settings: {
                theme: 'Temainställningar',
                refresh: 'Uppdatera inställningar från telefon',
                explanatory_intro: 'Dessa inställningar hämtas från telefonappen när du väljer detta alternativ. Du kan också ändra dem manuellt på den här sidan.',
                base: 'Grundtema',
                daynight: 'Dag / Natt',
                light: 'Ljust',
                dark: 'Mörkt',
                black: 'Svart',
                primary: 'Primär färg',
                darkprimary: 'Primär mörk färg',
                accent: 'Accentfärg',
                applyeverywhere: 'Applicera färger på alla konversationer',
                applyprimary: 'Applicera primär färg på "App Bar"',
                messagetimestamp: 'Visa tidsstämpel på varje meddelande',
                conversationcategories: 'Visa konversationer i datumkategorier',
                webspecific: 'Webspecifika inställningar',
                advanced: 'Avancerade inställningar',
                shownotifs: 'Visa notiser',
                entersend: 'Använd Enter-knappen för att skicka meddelanden',
                showconversationsnotinfolders: 'Visa endast konversationer utanför mappar i huvudlistan',
                showunreadasdefault: 'Visa olästa konversationer som standard',
                yes: 'Ja',
                no: 'Nej',
                private_conversations_passcode_title: 'Lösenord för privata konversationer',
                private_conversations_passcode_description: 'Om du ställer in ett lösenord måste du ange det innan du tittar på privata konversationer',
                clean_up_old_messages_title: 'Rensa upp gamla meddelanden',
                clean_up_old_messages_description: 'Detta körs en gång per dag för att radera alla meddelanden som är äldre än den valda tidsperioden',
                clean_up_old_messages: {
                    never: 'Aldrig',
                    one_week: 'En Vecka',
                    two_weeks: 'Två Veckor',
                    one_month: 'En Månad',
                    three_months: 'Tre Månader',
                    six_months: 'Sex Månader',
                    one_year: 'Ett År'
                },
                unknown_number_reception_title: 'Ta emot meddelanden från icke-kontakter',
                unknown_number_reception: {
                    default: 'Ta emot meddelanden normalt',
                    mute: 'Stäng av ljudet på konversationerna för att förhindra aviseringar',
                    block: 'Kassera omedelbart meddelandet som skräppost. Var försiktig och kom ihåg att du har aktiverat detta!'
                },
                auto_reply_configuration_title: 'Autosvarskonfiguration',
                auto_reply_configuration_description: 'Ställ in automatiska svar baserat på din situation',
                auto_reply: {
                    empty: 'Inga automatiska svar hittades.',
                    create: 'Skapa automatiskt svar',
                    keyword: 'Nyckelord',
                    response: 'Svar',
                    prompt: 'Vilken typ av automatiskt svar vill du skapa?',
                    type_contact: 'KONTAKT',
                    type_keyword: 'NYCKELORD',
                    edit: 'Redigera automatiskt svar',
                    edit_action: 'Redigera',
                    contact: 'Kontakt',
                    updated: 'Automatiskt svar uppdaterat',
                    update_failed: 'Kunde inte uppdatera automatiskt svar',
                    delete_confirm: 'Ta bort autosvar?',
                    deleted: 'Automatiskt svar raderat',
                    delete_failed: 'Kunde inte radera automatiskt svar',
                }
            },
            account: {
                upgrade_subscription: 'Vill du ändra eller uppgradera ditt abonnemang? Gå till "Mitt konto" i Android appen!',
                expiration_reminder: 'Påminnelse: Ditt Pulse SMS-konto förblir aktivt om du skickar ett meddelande inom 60 dagar, annars upphör kontot.'
            },
            experiments: {
                disclaimer: 'Varning',
                explanatory_intro: 'Dessa inställningar ges ingen support eller garantier att de kommer fortsätta finnas kvar. Som en app med öppen källkod är de användbara för att testa nya funktioner och förse utvecklare med verktyg för att applicera sina egna justeringar i appen. Använd försiktigt och förlita dig inte på dem om du inte underhåller dem själv. De är avsedda som experiment.',
                larger_app_bar: 'Visa större "App Bar"',
                unread_count_in_sidebar: 'Visa antal Olästa meddelanden i sidomenyn'
            },
            drafts: {
                title: 'Utkast',
                none: 'Inga utkast',
                unknown: 'Okänd konversation',
                image: 'Bild',
                video: 'Video',
                audio: 'Ljud',
                contact: 'Kontaktkort',
                attachment: 'Bilaga',
                copy: 'Kopiera text',
                copied: 'Utkast kopierat',
                delete: 'Radera',
                deleteconfirm: 'Radera utkasten för den här konversationen?',
                deleted: 'Utkast raderade'
            }
        }
    }
});
